'use client'

import { usePathname } from 'next/navigation'
import clsx from 'clsx'
import { useFeatureFlags } from '@node-space/hooks'

interface UKApprovalStampProps {
  countryCode: string
  className?: string
}

export const UKApprovalStamp = ({ countryCode, className }: UKApprovalStampProps) => {
  const { enablePromotionalBanner } = useFeatureFlags()
  const isPayout = usePathname()?.includes('payout')

  if (isPayout && countryCode === 'GB' && enablePromotionalBanner) {
    return (
      <div className={clsx('w-full', className)}>
        <p className="text-foreground-faint text-center text-sm">
          Approved by Archax Ltd on 30/10/2023
        </p>
      </div>
    )
  }
}
